import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  makeSelectApartment,
  selectAllApartments,
  selectError,
  selectIsLoading,
} from "../../features/apartments/selectors";
import { HeroHeader } from "../../components/HeroHeader";
import { Stack } from "../../components/Stack";
import "./style.css";
import { ImageCarousel } from "../../components/ImageCarousel";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Button } from "../../components/Button";
import { useEffect, useState } from "react";
import { initFadeInAnimation } from "../../animation";
import { HouseServices } from "../../components/HouseServices";
import { useTranslation } from "react-i18next";
import { Text } from "../../components/Text";
import { Loader } from "lucide-react";
import { Seo } from "../../components/Seo";
import { NotFound } from "../NotFound";
import { PageShell } from "../../components/PageShell";
import { useInitApp } from "../../hooks/useInitApp";
import { BOOKING_URL } from "../../constants/links";

gsap.registerPlugin(ScrollTrigger);

export const ApartmentPage = () => {
  const params = useParams();
  const { id } = params;
  const apartment = useSelector(makeSelectApartment(id ?? "monolocali"));
  const data = useSelector(selectAllApartments);
  const imageCover = apartment?.photos.find((ap) => ap.isMain === true)?.url;
  const imageList = apartment?.photos.slice(2, 9);
  const isLoading = useSelector(selectIsLoading);
  const isErrorAPI = useSelector(selectError);

  const { i18n, t } = useTranslation();
  const apartmentTitle =
    i18n.language === "it"
      ? apartment?.apartmenttypeit
      : apartment?.apartmenttypeen;
  const apartmentDescription =
    i18n.language === "it"
      ? apartment?.descriptionit
      : apartment?.descriptionen;

  useInitApp();
  useEffect(() => {
    if (isLoading) return;
    initFadeInAnimation(".fade-in");
  }, [isLoading]);

  const hasData = Boolean(apartment) && Boolean(data?.length);
  if (isLoading && !hasData) return <Loader />;
  if (isErrorAPI || !id || !data) return <NotFound />;
  if (!apartment) return <NotFound />;

  return (
    <PageShell>
      <Seo
        title={apartmentTitle || "Appartamento"}
        description={
          apartmentDescription ||
          "Dettagli e servizi dell'appartamento Isola Dei Mori."
        }
        type="article"
      />

      {apartment && (
        <Stack flexDirection="column">
          <HeroHeader
            title={
              i18n.language === "it"
                ? apartment?.apartmenttypeit
                : apartment?.apartmenttypeen
            }
            imgSrc={imageCover || ""}
            className="parallax"
          />
          <Stack className="main-content" flexDirection="column">
            <div className="first-content fade-in ">
              <div className="description-container">
                <span className="desctiption">
                  {i18n.language === "it"
                    ? apartment?.descriptionit
                    : apartment?.descriptionen}
                </span>
                <Stack flex={1} justifycontent="center" paddingvertical={20}>
                  <Button
                    buttonTitle={t("book-now")}
                    icon="ArrowForwardIos"
                    onClick={() =>
                      window.open(BOOKING_URL)
                    }
                  />
                </Stack>
              </div>
              <Stack gap={40} wrap className="image-wrap-width" flex={1}>
                <div className="image1-container">
                  <img
                    src={apartment?.photos[0]?.url}
                    alt="Apartment Front"
                    style={{ opacity: 1 }}
                  />
                </div>
                <div className="image1-container">
                  <img
                    src={apartment?.photos[1]?.url}
                    alt="Apartment Front"
                    style={{ opacity: 1 }}
                  />
                </div>
              </Stack>
              <Stack
                flexDirection="column"
                alignitems="center"
                className="house-services"
                gap={40}
              >
                <Text fontSize="lg" bold>
                  {t("find")}
                </Text>
                <HouseServices
                  doublebeds={apartment.doublebed}
                  singlebeds={apartment.singlebed}
                  sofabeds={apartment.sofabed}
                  wifi={apartment.haswifi}
                  hasairconditioning={apartment.hasairconditioning}
                />
              </Stack>
            </div>
            <div className="carousel-content ">
              {imageList && <ImageCarousel imageList={imageList} />}
            </div>
          </Stack>
        </Stack>
      )}
    </PageShell>
  );
};
